import { apiClient } from '../utils/api-client'
import type { ExerciseCategory } from '../types/exercise'

interface ExerciseCategoriesResponse {
  data: Array<{ id: string; type: string; attributes: ExerciseCategory }>
}

class ExerciseCategoriesService {
  async list(): Promise<ExerciseCategory[]> {
    const response = await apiClient.get('/api/exercise_categories', { requireAuth: true })
    const json: ExerciseCategoriesResponse = await response.json()
    return json.data.map((d) => ({ ...d.attributes, id: d.id }))
  }
}

export const exerciseCategoriesService = new ExerciseCategoriesService()
